import { Box } from '@acko-tech/building-blocks.ui.common';
import { Text } from '@acko-tech/building-blocks.ui.typography';
import styled from 'styled-components';

export const DashcamContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: #FFFFFF;
`;

export const Heading = styled(Text)`
    color: #000;
    font-family: "Euclid Circular B";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 20px;
`;

export const ImageWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  margin-right: 100px;
`;

export const View360Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: transparent;
`;
